import Grid from '@mui/material/Grid';

import AvatarUpload from '~/ui/components/inputs/AvatarUpload';
import Input from '~/ui/components/inputs/Input';
import InputMask from '~/ui/components/inputs/InputMask';
import SelectEmailDomain from '~/ui/components/inputs/SelectEmailDomain';

import type { PersonalDetailsLeftColumnProps } from '../types';

import styles from '../Form.module.scss';

const CombinedEmailRow = ({
  isEdit,
  isPending,
  register,
  errors,
  control,
  emailDomainOptions,
}: Pick<
  PersonalDetailsLeftColumnProps,
  'isEdit' | 'isPending' | 'register' | 'errors' | 'control' | 'emailDomainOptions'
>) => (
  <div className={styles.combinedInputWrapper}>
    <Input
      combinedInput={!isEdit || isPending}
      disabled={isEdit && isPending}
      register={register}
      errors={errors}
      name="email"
      label="Email"
    />
    {(!isEdit || isPending) && (
      <SelectEmailDomain
        isDisabled={isEdit}
        name="emailDomain"
        control={control}
        errors={errors}
        options={emailDomainOptions}
      />
    )}
  </div>
);

const PersonalDetailsLeftColumn = ({
  isEdit,
  isPending,
  emailDomainOptions,
  control,
  register,
  errors,
}: Pick<
  PersonalDetailsLeftColumnProps,
  'isEdit' | 'isPending' | 'emailDomainOptions' | 'control' | 'register' | 'errors'
>) => (
  <Grid
    size={{
      sm: 6,
    }}
  >
    <Grid
      container
      spacing={2}
      size={{
        sm: 12,
      }}
    >
      <Grid
        size={{
          sm: 12,
        }}
      >
        <Input register={register} errors={errors} name="firstName" label="First Name" />
      </Grid>
      <Grid
        size={{
          sm: 12,
        }}
      >
        <Input register={register} errors={errors} name="lastName" label="Last Name" />
      </Grid>
      <Grid
        size={{
          sm: 12,
        }}
      >
        <InputMask control={control} errors={errors} name="phone" label="Phone" />
      </Grid>
      <Grid
        size={{
          sm: 12,
        }}
      >
        <CombinedEmailRow
          isEdit={isEdit}
          isPending={isPending}
          register={register}
          errors={errors}
          control={control}
          emailDomainOptions={emailDomainOptions}
        />
      </Grid>
      <Grid
        size={{
          sm: 12,
        }}
      >
        <AvatarUpload control={control} name="photo" errors={errors} isPhoto />
      </Grid>
    </Grid>
  </Grid>
);

export default PersonalDetailsLeftColumn;
